import { Link, LinkProps } from '@chakra-ui/react';
import { useFlag } from '@unleash/proxy-client-react';
import COLORS from 'constants/colors';
import { FeatureFlag } from 'constants/feature-flags';
import { usePopOutInstructionsLink } from 'store/pop-out-instructions';

export const AppLink = (
  props: LinkProps & {
    showInFrame?: boolean;
    innerHtmlToScroll?: string;
  },
) => {
  const setPopOutInstructionsLink = usePopOutInstructionsLink(
    (state) => state.setPopOutInstructionsLink,
  );

  const popOutInstructionsEnabled = useFlag(
    FeatureFlag.PopOutInstructionsEnabled,
  );

  return props.showInFrame && popOutInstructionsEnabled ? (
    <Link
      fontWeight="600"
      variant="underline"
      onClick={() =>
        setPopOutInstructionsLink(
          props.href || null,
          props.innerHtmlToScroll || null,
        )
      }
      outline="none"
      style={{
        lineHeight: '12px'
      }}
      _focus={{
        outline: `1px solid ${COLORS.FINCH.PURPLE}`,
        borderRadius: 0,
      }}
      {...props}
      target="_self"
      href="#"
    />
  ) : (
    <Link
      fontWeight="600"
      variant="underline"
      outline="none"
      style={{
        lineHeight: '12px'
      }}
      _focus={{
        outline: `1px solid ${COLORS.FINCH.PURPLE}`,
        borderRadius: 0,
      }}
      {...props}
      href={props.href}
    />
  );
};
